<script>
  import Footer from 'src/pc/components/Footer'
  export default {
    extends: Footer
  }
</script>

<style>
  .footerArea {
    min-width: unset !important;
    padding: 0 15px;
  }
  .footerArea .inner {
    width: 100% !important;
    border-top: 1px solid #000 !important;
    padding: 0 0 25px 0 !important;
  }
  .footerArea .inner ul {
    display: block !important;
    width: 100% !important;
    padding: 25px 0 0 0 !important;
    border: 0 !important;
    min-height: unset !important;
  }
  .footerArea .inner li {
    font-size: 13px !important;
    font-weight: 400 !important;
    text-align: center !important;
    margin-bottom: 10px !important;
    line-height: 1.6em !important;
  }
  .footerArea .inner li.copy {
    margin-bottom: 10px !important;
  }
  .footerArea .inner li:last-child {
    margin-bottom: 0 !important;
  }
  .footerArea .inner li p {
    font-size: 15px !important;
    margin-bottom: 8px !important;
  }
  .footerArea .inner .bi .img {
    margin-bottom: 10px !important;
  }
  .footerArea .inner .bi .img img {
    height: 91px;
  }
  .footerArea .inner .company li a {
    display: inline-block !important;
/*    margin: 0 10px;*/
  }
  .footerArea .inner .company li.channel_ctnr {
    margin-top: 25px;
  }
  .footerArea .inner .etc li {
    margin-bottom: 25px !important;
  }
  .footerArea .inner .etc li a.sns {
    padding: 5px 14px 0 14px !important;
  }
  .footerArea .inner .etc li a.sns img {
    height: 36px !important;
  }
  .q-dialog__inner .info_pop {
    width: 100vw !important;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
    position: absolute;
    left: 0;
    right: 0;
	}
  
  /* FAQ/Team Modal */
  .q-dialog__inner .modal_faq,
  .q-dialog__inner .modal_team {
    width: 100vw;
    height: 100%;
    max-height: unset !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
    overflow-y: hidden;
    padding-top: 60px;
  }
  .q-dialog__inner .modal_faq h5,
  .q-dialog__inner .modal_team h5 {
    font-size: 20px;
    height: 60px;
  }
  .q-dialog__inner .modal_faq .contain,
  .q-dialog__inner .modal_team .contain {
    padding: 0 20px 20px;
    overflow-y: scroll;
  }
  .q-dialog__inner .modal_team ul {
    padding: 22px 20px;
  }
  .q-dialog__inner .modal_team ul li.name {
    font-size: 17px;
  }
  .q-dialog__inner .modal_team ul li.name span {
    display: block;
    margin-left: 0;
    margin-top: 10px;
    line-height: 1.4em;
  }
  .q-dialog__inner .modal_team ul li.contact {
    margin-top: 6px;
    margin-bottom: 15px;
    letter-spacing: -0.02em;
    line-height: 1.2em;
  }
  .q-dialog__inner .modal_team ul:last-child li.contact {
    margin-top: 10px;
  }
  .q-dialog__inner .modal_team ul li.contact h6 {
    font-size: 17px;
  }
  .q-dialog__inner .modal_team ul li.desc {
    word-break: normal;
  }
</style>